import { defineMessages } from 'react-intl';

export default defineMessages({
  approveBudgetTitle: {
    id: 'App.RentForecast.ApproveBudget.Title',
    defaultMessage: 'Approve Budget',
  },
  approveBudgetText: {
    id: 'App.RentForecast.ApproveBudget.Text',
    defaultMessage:
      'Approving this budget will create a new Approved Budget ' +
      'record using all current data. Approved Rents will be fixed and will no ' +
      'longer update automatically with floor plan rent changes. Make sure all ' +
      'budget details are finalized before continuing.',
  },
  saveSuccess: {
    id: 'App.RentForecast.ApproveBudget.Submit.Success',
    defaultMessage: 'Budget successfully approved.',
  },
  saveFailed: {
    id: 'App.RentForecast.ApproveBudget.Submit.Failed',
    defaultMessage: 'Could not approve budget.',
  },
});
